interface SectionLabelProps {
  children: React.ReactNode
  className?: string
}

export function SectionLabel({ children, className = '' }: SectionLabelProps) {
  return (
    <div
      className={`flex items-center gap-3 ${className}`}
      style={{ marginBottom: 24 }}
    >
      <div
        style={{
          width: 36,
          height: 2,
          background: 'var(--accent)',
        }}
      />
      <span
        style={{
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: '0.22em',
          textTransform: 'uppercase',
          color: 'var(--accent)',
        }}
      >
        {children}
      </span>
    </div>
  )
}
